import React, { useState, useEffect } from 'react';

//3rd party
import moment from 'moment';

// i18n
import { useTranslations } from '../context/TranslationsContext';

const Greeting = () => {
    const { t, loading: i18nLoading } = useTranslations();

    //Variables
    const name = localStorage.getItem('voornaam') || '';
    const [greeting, setGreeting] = useState('');

    useEffect(() => {
        const hour = parseInt(moment(Date.now()).format('H'));
        if (hour > 5 && hour < 12) { 
            setGreeting(t('good_morning', 'Good morning')) 
        } else if (hour > 11 && hour < 18) { 
            setGreeting(t('good_afternoon', 'Good afternoon')) 
        } else { 
            setGreeting(t('good_evening', 'Good evening')) 
        }
    }, []);

    return (
        <span>{greeting} {name}</span>
    );
}

export default Greeting;